module.exports = __webpack_public_path__ + "img/strap_length.de0e49d6.png";